import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import './style.scss';

const TaxonomyProjectCategories = ({ entity, className }) => {
  const classNames = c('TaxonomyProjectCategories', className);

  const name = entity.getIn(['name', 0, 'value'], '');
  const illustration = entity.getIn(['field_illustration', 0, 'entity', 'field_document', 0], Immutable.Map());

  return (
    <div className={classNames}>
      <img
        src={illustration.get('url', illustration.get('source'))}
        alt={illustration.get('description', name)}
      />
    </div>
  );
};

export default TaxonomyProjectCategories;
